import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Link, Redirect } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getUserApi, getCube, assignCubes } from "api";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";

class FillerAssignCube extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      ...this.props,
      validation: "",
      userList: [],
      stockList: [],
      history: props.history,
      props: props?.location?.query
        ? props?.location?.query
        : { data: null, isEdit: 1 },
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  handleSubmit(values) {
    const data = assignCubes({ id: values.cubeBeltId, data: values });
    console.log(data);
  }
  async componentDidMount() {
    const machineOperator = await getUserApi({
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000004",
    });

    if (this.state.props.isEdit == 1) {
      const stock = await getCube({
        page: null,
        limit: null,
        machineOperatorId: null,
        fromDate: null,
        toDate: null,
        beltId: null,
        name:null,
      });
      if(stock && stock.data){
        this.setState({
          userList: machineOperator.data.users,
          stockList: stock.data.cubeBelts,
        });
      }
      
    } else {
      this.setState(
        {
          userList: machineOperator.data.users,
          stockList: [this.state.props.data.stockFillerInWard],
        },
        () => console.log(this.state.userList)
      );
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "filler flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Assign Belt" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.props.isEdit == 1
                          ? {
                              cubeBeltId: "",
                              machineOperatorId: "",
                              remarks: "",
                            }
                          : {
                              cubeBeltId:
                                this.state.props.data.stockFillerInWard.cubeId,
                              machineOperatorId:
                                this.state.props.data.machineOperatorId,
                              remarks: this.state.props.data.remarks,
                            }
                      }
                      validationSchema={Yup.object().shape({
                        cubeBeltId: Yup.string().required(
                          "This Value is Required"
                        ),
                        machineOperatorId: Yup.string().required(
                          "This Value is Required"
                        ),
                        remarks: Yup.string().max(512).nullable().notRequired(),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values, validateForm }) => (
                        <Form className="needs-validation">
                          <div className="d-lg-flex d-block justify-content-between">
                            <div>
                              <h4 className="pb-3 text-black fw-bold">
                                Assign Belt (100% filled)
                              </h4>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="date"
                                className="col-12 col-sm-2 col-lg-5"
                              >
                                <h5 className="fs-5 fw-bold text-black">
                                  Assign Date:
                                </h5>
                              </Label>
                              <div className="col-12 col-sm-5 col-lg-6">
                                <Field
                                  className={
                                    "border-0 fs-5" +
                                    (errors.date && touched.date
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="date"
                                  name="date"
                                />
                                <ErrorMessage
                                  name="date"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="cubeBeltId"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                Belt ID
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                className={
                                  "form-control form-select fs-5" +
                                  (errors.cubeBeltId && touched.cubeBeltId
                                    ? " is-invalid"
                                    : "")
                                }
                                name="cubeBeltId"
                                as="select"
                                disabled={
                                  this.state.props.isEdit == 1 ? false : true
                                }
                              >
                                <option value="" disabled>
                                  select
                                </option>
                                {this.state.stockList.map(x => (
                                  <option key={x.id} value={x.id}>
                                    {x.cubeId}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="cubeId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="machineOperatorId"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                              {this.props.t("Machine Operator")}
                              </h5>
                            </Label>
                            <div className="col-md-10 col-12">
                              <Field
                                className={
                                  "form-control form-select fs-5" +
                                  (errors.machineOperatorId &&
                                  touched.machineOperatorId
                                    ? " is-invalid"
                                    : "")
                                }
                                name="machineOperatorId"
                                as="select"
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                              >
                                <option value="" disabled>
                                  select
                                </option>
                                {this.state.userList.map(x => (
                                  <option key={x.id} value={x.id}>
                                    {x.name}
                                  </option>
                                ))}
                              </Field>
                              <ErrorMessage
                                name="machineOperatorId"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <Label
                              htmlFor="remarks"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t("Filler Notes")}
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.remarks && touched.remarks
                                    ? " is-invalid"
                                    : "")
                                }
                                type="text"
                                name="remarks"
                                as="textarea"
                                rows="5"
                                placeholder="Please Take of HPHT First Priority"
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                              />
                              <ErrorMessage
                                name="remarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="col-md-12 text-center text-md-end mt-4">
                            {this.state.props.isView ? (
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                onClick={() => {
                                  this.state.history.goBack();
                                }}
                              >
                                Back
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                onClick={() => {
                                  validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.handleSubmit(values);
                                      }
                                    })
                                    .catch(err => console.log(err));
                                }}
                              >
                                Assign
                              </Button>
                            )}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(FillerAssignCube);
